"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromoTag;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _api = require("@whitbread-eos/api");
var _utils = require("@whitbread-eos/utils");
var _react2 = _interopRequireWildcard(require("react"));
var _icons = require("../../assets/icons");
var _Icon = _interopRequireDefault(require("../Icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isNonEmptyString = value => typeof value === 'string' && value.trim().length > 0;
function PromoTag(_ref) {
  var {
    rateDiscountTags,
    customStyleName
  } = _ref;
  var {
    [_api.FT_PI_PROMO_CODE_LANDING_PAGE]: isPromoCodeLandingPageEnabled
  } = (0, _utils.useFeatureToggle)();
  var [validTags, setValidTags] = (0, _react2.useState)([]);
  (0, _react2.useEffect)(() => {
    if (isPromoCodeLandingPageEnabled) {
      var _rateDiscountTags$fil;
      var filteredTags = (_rateDiscountTags$fil = rateDiscountTags === null || rateDiscountTags === void 0 ? void 0 : rateDiscountTags.filter(isNonEmptyString)) !== null && _rateDiscountTags$fil !== void 0 ? _rateDiscountTags$fil : [];
      setValidTags(filteredTags);
    } else {
      setValidTags([]);
    }
  }, [isPromoCodeLandingPageEnabled, rateDiscountTags]);
  if (validTags.length === 0) return null;
  var getCustomStyle = customStyleName => {
    switch (customStyleName) {
      case 'rateItem':
        return customStyles.rateItemStyles;
      case 'basketComponent':
        return customStyles.basketComponentStyles;
      case 'BookingSummaryCard':
        return customStyles.BookingSummaryCardStyles;
      default:
        return {};
    }
  };
  var mergerdStyles = _objectSpread(_objectSpread({}, basePlanRateStyles), getCustomStyle(customStyleName));
  return (0, _jsxRuntime.jsx)(_react.Flex, _objectSpread(_objectSpread({
    "data-testid": "PromotionTagComponent"
  }, promoWrapper), {}, {
    children: validTags.map((tag, index) => (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, mergerdStyles), {}, {
      children: [(0, _jsxRuntime.jsx)(_Icon.default, _objectSpread({
        svg: (0, _jsxRuntime.jsx)(_icons.Price, {})
      }, iconStyles)), tag.trim()]
    }), index))
  }));
}
var iconStyles = {
  display: 'flex',
  alignItems: 'center',
  height: '1rem',
  width: '1rem',
  marginRight: '0.1875rem'
};
var basePlanRateStyles = {
  color: 'primary',
  backgroundColor: 'tooltipInfo',
  display: 'inline-flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '1.625rem',
  borderRadius: '0.25rem',
  padding: '0.25rem 0.5rem',
  fontSize: '0.8125rem',
  fontWeight: 'bold',
  whiteSpace: 'nowrap'
};
var promoWrapper = {
  display: 'inline-flex'
};
var customStyles = {
  rateItemStyles: {
    mx: 'sm'
  },
  basketComponentStyles: {
    mx: 'sm'
  },
  BookingSummaryCardStyles: {
    mt: 'sm'
  }
};